import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/store/layout.tsx");
